// extracted by mini-css-extract-plugin
module.exports = {"container":"O-RBc5Jos9sCXgBJD2rHZ","secondaryText":"_3eWBFswi0yQDMGe8mIuRIc","mainText":"_1JjTJgzTynsoAMaRTbPYko"};